import {Alert, Button, Space} from "antd";
import {ServiceOrders} from "../../../../components/store/services/orders";
import {ServiceList} from "../../../../components/store/services";
import {FullPageLoader} from "../../../../components/full-page-loader";
import {useState} from "react";
import {useGetStoreServices} from "../../../../react-query-hooks/store/services/get-services";
import {EmptyState} from "../../../../components/empty-state";
import {StyledNoUpcomingCallBox} from "../../../../components/calls/upcoming-calls/upcoming-calls.style";
import {Link} from "react-router-dom";

export function ServicesEntryPoint() {
  const [currentPage, setCurrentPage] = useState(1);
  const useGetStoreServicesQuery = useGetStoreServices(currentPage, 5);

  if (useGetStoreServicesQuery.isLoading) {
    return <FullPageLoader />;
  }
  if (useGetStoreServicesQuery.isError) {
    return <Alert message={useGetStoreServicesQuery.error.message} type="error" />;
  }

  console.log({Se: useGetStoreServicesQuery.data});
  return (
    <div>
      {useGetStoreServicesQuery.data.data.productServices.length > 0 ? (
        <Space size={24} direction="vertical" style={{display: "flex"}}>
          <ServiceOrders />
          <ServiceList
            currentPage={currentPage}
            data={useGetStoreServicesQuery.data.data.productServices}
            isFetching={useGetStoreServicesQuery.isFetching}
            isLoading={useGetStoreServicesQuery.isLoading}
            isPreviousData={useGetStoreServicesQuery.isPreviousData}
            paginationMeta={useGetStoreServicesQuery.data.meta}
            setCurrentPage={setCurrentPage}
          />
        </Space>
      ) : (
        // <EmptyState message="You do not have any services at the moment." />
        <StyledNoUpcomingCallBox>
          <p className="info-text">You do not have any services at the moment.</p>
          <Link to="/products/services/new">
            <Button type="primary" size="small">
              Create a new service
            </Button>
          </Link>
        </StyledNoUpcomingCallBox>
      )}
    </div>
  );
}
